// extracted by mini-css-extract-plugin
export var fullScreen = "Loading-module--full-screen--Skcgc";
export var loading = "Loading-module--loading--6BaO3";
export var loadingText = "Loading-module--loading-text--hGFv7";
export var primary = "#06004d";
export var secondary = "#4dafd7";